import { css } from 'aphrodite';
import * as React from 'react';
import { baseStyleSheet } from '../../../../web/styles/styles';
import { styleSheet } from './styles';

export const DisabledTabContent = ({ children }: { children: React.ReactNode }) => {
	return (
		<div className={css(styleSheet.disabledTabContent)}>
			<div className={css(baseStyleSheet.absoluteCenter)}>{children}</div>
		</div>
	);
};
